import React, { useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import {
  TextField,
  Button,
  Container,
  Paper,
  MenuItem,
  DialogActions,
  Grid,
  Box,
  DialogTitle,
  DialogContent,
  FormControlLabel,
  Switch,
  Stack,
  Typography,
} from "@mui/material";
import { useCreateOrganization } from "..";
import UploadFileButton from "../../UploadFileButton/UploadFileButton";

const validationSchema = yup.object({
  name: yup.string().required(),
  piva: yup.string(),
  address: yup.string(),
  city: yup.string(),
  province: yup.string(),
  cap: yup.string(),
  phone: yup.string(),
  email: yup.string().email().required(),
  ragsoc: yup.string().optional(),
  include_h3k_logo: yup.bool(),
  client_logo_pos: yup.string(),
});

function CreateOrganization({ closeModal }) {
  const addOrgMutation = useCreateOrganization(closeModal);
  //const [file, setFile] = useState(null);

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      piva: "",
      address: "",
      city: "",
      province: "",
      cap: "",
      phone: "",
      ragsoc: "",
      include_h3k_logo: true,
      client_logo_pos: "SX",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      addOrgMutation.mutate({ ...values });
    },
  });

  const handleFileChange = (event) => {
    formik.setFieldValue("file", event.target.files[0]);
  };

  return (
    <>
      <DialogTitle>Aggiungi organizzazione</DialogTitle>
      <DialogContent>
        <form onSubmit={formik.handleSubmit}>
          <Grid container>
            <Grid item xs={6}>
              <Box sx={{ margin: "2vmin" }}>
                <TextField
                  id="name"
                  name="name"
                  label="Nome"
                  fullWidth
                  margin="dense"
                  variant="standard"
                  type="text"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                />
                <TextField
                  id="piva"
                  name="piva"
                  label="P. IVA"
                  fullWidth
                  margin="dense"
                  variant="standard"
                  type="text"
                  value={formik.values.piva}
                  onChange={formik.handleChange}
                />
                <TextField
                  id="phone"
                  name="phone"
                  label="Cellulare"
                  fullWidth
                  margin="dense"
                  variant="standard"
                  type="text"
                  value={formik.values.phone}
                  onChange={formik.handleChange}
                />
                <TextField
                  id="email"
                  name="email"
                  label="Email"
                  fullWidth
                  margin="dense"
                  variant="standard"
                  type="text"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  error={formik.touched.email && Boolean(formik.errors.email)}
                  helperText={formik.touched.email && formik.errors.email}
                />
                <TextField
                  id="ragSocClient"
                  name="ragSocClient"
                  label="Ragione Sociale Cliente"
                  margin="dense"
                  variant="standard"
                  type="text"
                  value={formik.values.ragSocClient}
                  onChange={formik.handleChange}
                />
                <UploadFileButton
                  file={formik.values.file}
                  handleFileChange={handleFileChange}
                />
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box sx={{ margin: "2vmin" }}>
                <TextField
                  id="address"
                  name="address"
                  label="Indirizzo"
                  fullWidth
                  margin="dense"
                  variant="standard"
                  type="text"
                  value={formik.values.address}
                  onChange={formik.handleChange}
                />
                <TextField
                  id="city"
                  name="city"
                  label="Citta"
                  fullWidth
                  margin="dense"
                  variant="standard"
                  type="text"
                  value={formik.values.city}
                  onChange={formik.handleChange}
                />
                <TextField
                  id="province"
                  name="province"
                  label="Provincia"
                  fullWidth
                  margin="dense"
                  variant="standard"
                  type="text"
                  value={formik.values.province}
                  onChange={formik.handleChange}
                />
                <TextField
                  id="cap"
                  name="cap"
                  label="CAP"
                  fullWidth
                  margin="dense"
                  variant="standard"
                  type="text"
                  value={formik.values.cap}
                  onChange={formik.handleChange}
                />
                <FormControlLabel
                  sx={{
                    margin: "8px",
                  }}
                  control={
                    <Switch
                      name="include_h3k_logo"
                      value={formik.values.include_h3k_logo}
                      checked={formik.values.include_h3k_logo}
                      onChange={formik.handleChange}
                    />
                  }
                  label="Includi logo Health3000"
                  labelPlacement="start"
                />

                <TextField
                  margin="dense"
                  fullWidth
                  id="client_logo_pos"
                  name="client_logo_pos"
                  label="Posizione Logo Org."
                  select
                  variant="standard"
                  defaultValue={"SX"}
                  onChange={formik.handleChange}
                  value={formik.values.client_logo_pos}
                >
                  <MenuItem value={"DX"}>DX</MenuItem>
                  <MenuItem value={"SX"}>SX</MenuItem>
                </TextField>
              </Box>
            </Grid>
            <Container sx={{ padding: "1vmin" }}>
              <DialogActions>
                <Button disabled={addOrgMutation.isLoading} type="submit">
                  Conferma
                </Button>
                <Button
                  disabled={addOrgMutation.isLoading}
                  onClick={formik.handleReset}
                  color="error"
                >
                  Reset
                </Button>
                <Button
                  disabled={addOrgMutation.isLoading}
                  onClick={closeModal}
                  color="error"
                >
                  Chiudi
                </Button>
              </DialogActions>
            </Container>
          </Grid>
        </form>
      </DialogContent>
    </>
  );
}

export default CreateOrganization;
